import React, { useState, useEffect } from "react";

export const RandomTime = () => {
    const times = [
        { min: 1, max: 1, label: "час назад" },
        { min: 2, max: 4, label: "часа назад" },
        { min: 5, max: 9, label: "часов назад" },
    ];

    const [randomTime, setRandomTime] = useState(null);

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * times.length);
        const selectedTime = times[randomIndex];
        const randomNumber = Math.floor(Math.random() * (selectedTime.max - selectedTime.min + 1)) + selectedTime.min;

        setRandomTime({ number: randomNumber, label: selectedTime.label });
    }, []);

    if (!randomTime) return null;

    return (
        <span>
            {randomTime.number} {randomTime.label}
        </span>
    );
};
